const alphaNumericCharset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
export function generateUniqueId(prefix) {
    return "".concat(prefix, "-z").concat(getTimePart(Date.now()), "-").concat(getRandomPart());
}
function getRandomPart() {
    return Array.from(crypto.getRandomValues(new Uint8Array(16))).map((i)=>alphaNumericCharset[i % alphaNumericCharset.length]).join('');
}
function getTimePart(timestamp) {
    let timePart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (timestamp === 0) return timePart;
    const newTimePart = alphaNumericCharset[timestamp % alphaNumericCharset.length].concat(timePart);
    const newTimestamp = Math.floor(timestamp / alphaNumericCharset.length);
    return getTimePart(newTimestamp, newTimePart);
}
